(function(){
  function init(){
  var root = document.querySelector('[data-pgcs]');
  if(!root || root.__pgcsInit) return;
  var _d = document.querySelector('[data-pgcs-data]');
  var STORIES = []; try{ STORIES = _d ? JSON.parse(_d.textContent) : []; }catch(_e){ return; }
  if(!STORIES.length) return;
  root.__pgcsInit = 1;
  stopPgcsMo();
  var rail = root.querySelector('[data-rail]');
  var modal = root.querySelector('[data-modal]');
  var video = root.querySelector('[data-video]');
  var bars = root.querySelector('[data-bars]');
  var capName = root.querySelector('[data-capname]');
  var capTag = root.querySelector('[data-captag]');
  var muteBtn = root.querySelector('[data-mute]');
  var cur = 0, milestones = {};

  var ICON_VOL = '<svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.8-1-3.3-2.5-4v8c1.5-.7 2.5-2.2 2.5-4zM14 3.2v2.1c2.9.9 5 3.5 5 6.7s-2.1 5.8-5 6.7v2.1c4-.9 7-4.5 7-8.8s-3-7.9-7-8.8z"/></svg>';
  var ICON_MUTE = '<svg viewBox="0 0 24 24"><path d="M16.5 12c0-1.8-1-3.3-2.5-4v2.2l2.5 2.5V12zM19 12c0 .9-.2 1.8-.5 2.6l1.5 1.5c.6-1.2 1-2.6 1-4.1 0-4.3-3-7.9-7-8.8v2.1c2.9.9 5 3.5 5 6.7zM4.3 3L3 4.3 7.7 9H3v6h4l5 5v-6.7l4.3 4.3c-.7.5-1.4.9-2.3 1.1v2.1c1.4-.3 2.7-.9 3.8-1.8L19.7 21 21 19.7 4.3 3zM12 4L9.9 6.1 12 8.2V4z"/></svg>';

  // Filterable view: array of indexes into STORIES
  var view = STORIES.map(function(_, i){ return i; });

  function buildRail(){
    rail.innerHTML = '';
    view.forEach(function(gi, vi){
      var s = STORIES[gi];
      var b = document.createElement('button');
      b.className = 'pgcs__bubble'; b.setAttribute('role','listitem');
      b.setAttribute('aria-label','Play video: ' + s.name);
      b.innerHTML =
        '<span class="pgcs__card">' +
          '<img class="pgcs__thumb" src="' + s.thumb + '" loading="lazy" decoding="async" '+
            'width="150" height="266" alt="' + s.name + ' — Premium Grounding customer">' +
          '<span class="pgcs__grad"></span>' +
          '<span class="pgcs__play"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></span>' +
        '</span>' +
        '<span class="pgcs__name">' + s.name + '</span>' +
        (s.tag ? '<span class="pgcs__tag">' + s.tag + '</span>' : '');
      b.addEventListener('click', function(){ open(vi); });
      rail.appendChild(b);
    });
    rail.scrollLeft = 0;
    if(typeof updateScrollBtns === 'function') setTimeout(updateScrollBtns, 30);
  }
  buildRail();

  // Filter tabs
  var tabs = root.querySelector('[data-tabs]');
  if(tabs){
    tabs.addEventListener('click', function(e){
      var t = e.target.closest('[data-cat]');
      if(!t) return;
      var cat = t.getAttribute('data-cat');
      tabs.querySelectorAll('[data-cat]').forEach(function(b){ b.setAttribute('aria-pressed', String(b===t)); });
      view = STORIES.map(function(_, i){ return i; }).filter(function(i){
        return cat === 'all' || STORIES[i].cat === cat;
      });
      buildRail();
      try{ (window.dataLayer = window.dataLayer || []).push({event:'pg_story_filter', filter:cat}); }catch(_e){}
    });
  }

  // Rail scroll arrows ("more videos")
  var sLeft = root.querySelector('.pgcs__scroll--left');
  var sRight = root.querySelector('.pgcs__scroll--right');
  var railwrap = root.querySelector('.pgcs__railwrap');
  function updateScrollBtns(){
    var max = rail.scrollWidth - rail.clientWidth - 4;
    var atEnd = rail.scrollLeft >= max;
    if(sLeft) sLeft.hidden = rail.scrollLeft <= 4;
    if(sRight) sRight.hidden = atEnd;
    if(railwrap) railwrap.classList.toggle('pgcs--atend', atEnd);
  }
  rail.addEventListener('scroll', updateScrollBtns, {passive:true});
  window.addEventListener('resize', updateScrollBtns);
  setTimeout(updateScrollBtns, 50);
  // Mobile: one-time nudge so customers see the row scrolls sideways
  try{
    if(window.matchMedia('(max-width:740px)').matches){
      setTimeout(function(){
        rail.scrollTo({left:46,behavior:'smooth'});
        setTimeout(function(){ rail.scrollTo({left:0,behavior:'smooth'}); }, 750);
      }, 900);
    }
  }catch(e){}

  function track(name, extra){
    var s = STORIES[view[cur]] || {};
    var payload = Object.assign({event:name, video_id:s.id, video_name:s.name, video_index:cur}, extra||{});
    try{ (window.dataLayer = window.dataLayer || []).push(payload); }catch(e){}
    try{ if(window.gtag) window.gtag('event', name, payload); }catch(e){}
    try{ if(window.fbq) window.fbq('trackCustom', name, payload); }catch(e){}
  }

  function buildBars(){
    bars.innerHTML='';
    view.forEach(function(){ var d=document.createElement('div'); d.className='pgcs__bar';
      d.innerHTML='<i></i>'; bars.appendChild(d); });
  }
  function paintBars(){
    var fills = bars.querySelectorAll('.pgcs__bar i');
    for(var i=0;i<fills.length;i++) fills[i].style.width = i<cur ? '100%' : (i>cur ? '0%' : fills[i].style.width);
  }

  function load(i){
    cur = i; milestones = {};
    var s = STORIES[view[i]];
    video.poster = s.pposter || s.poster;
    video.src = s.video;
    capName.textContent = s.name;
    capTag.textContent = s.tag || '';
    paintBars();
    root.querySelectorAll('.pgcs__side[data-prev],.pgcs__mbtn[data-prev]').forEach(function(b){ b.disabled = (i===0); });
    root.querySelectorAll('.pgcs__side[data-next],.pgcs__mbtn[data-next]').forEach(function(b){ b.disabled = (i===view.length-1); });
    var p = video.play(); if(p && p.catch) p.catch(function(){});
    track('pg_story_play');
  }

  function open(i){
    buildBars();
    modal.hidden = false;
    document.body.classList.add('pgcs-lock');
    video.muted = false; syncMute();
    load(i);
    track('pg_story_open');
    document.addEventListener('keydown', onKey);
  }
  function close(){
    video.pause(); video.removeAttribute('src'); video.load();
    modal.hidden = true;
    document.body.classList.remove('pgcs-lock');
    document.removeEventListener('keydown', onKey);
  }
  function next(){ if(cur < view.length-1) load(cur+1); else close(); }
  function prev(){ if(cur > 0) load(cur-1); }

  function syncMute(){ muteBtn.innerHTML = video.muted ? ICON_MUTE : ICON_VOL; }

  // Progress + milestones
  video.addEventListener('timeupdate', function(){
    if(!video.duration) return;
    var pct = video.currentTime / video.duration;
    var fill = bars.children[cur] && bars.children[cur].querySelector('i');
    if(fill) fill.style.width = (pct*100).toFixed(2) + '%';
    [25,50,75].forEach(function(m){
      if(pct*100 >= m && !milestones[m]){ milestones[m]=1; track('pg_story_progress',{percent:m}); }
    });
  });
  video.addEventListener('ended', function(){ track('pg_story_complete'); next(); });

  // Controls (event delegation for the duplicated prev/next/close buttons)
  root.addEventListener('click', function(e){
    var sc = e.target.closest('[data-scroll]');
    if(sc){ rail.scrollBy({left: parseInt(sc.getAttribute('data-scroll'),10) * Math.round(rail.clientWidth*0.8), behavior:'smooth'}); return; }
    var t = e.target.closest('[data-close],[data-next],[data-prev],[data-pause],[data-mute],[data-share]');
    if(!t) return;
    if(t.hasAttribute('data-close')) return close();
    if(t.hasAttribute('data-next')) return next();
    if(t.hasAttribute('data-prev')) return prev();
    if(t.hasAttribute('data-pause')){ video.paused ? video.play() : video.pause(); return; }
    if(t.hasAttribute('data-mute')){ video.muted = !video.muted; syncMute(); return; }
    if(t.hasAttribute('data-share')){ doShare(); return; }
  });

  function doShare(){
    var url = location.href.split('#')[0];
    if(navigator.share){ navigator.share({title:document.title, url:url}).catch(function(){}); }
    else if(navigator.clipboard){ navigator.clipboard.writeText(url); t_flash('Link copied'); }
    track('pg_story_share');
  }
  function t_flash(msg){ /* lightweight, optional */ }

  function onKey(e){
    if(e.key==='Escape') close();
    else if(e.key==='ArrowDown'||e.key==='ArrowRight') next();
    else if(e.key==='ArrowUp'||e.key==='ArrowLeft') prev();
    else if(e.key===' '){ e.preventDefault(); video.paused?video.play():video.pause(); }
  }

  // Touch swipe (mobile): vertical swipe = prev/next, big swipe-down = close
  var ty=0, tx=0;
  var player = root.querySelector('.pgcs__player');
  player.addEventListener('touchstart', function(e){ ty=e.touches[0].clientY; tx=e.touches[0].clientX; }, {passive:true});
  player.addEventListener('touchend', function(e){
    var dy=e.changedTouches[0].clientY-ty, dx=e.changedTouches[0].clientX-tx;
    if(Math.abs(dy)>Math.abs(dx) && Math.abs(dy)>50){ dy>120 ? close() : (dy>0 ? prev() : next()); }
  }, {passive:true});
  } /* end init */
  if(document.readyState!=='loading'){ init(); }
  document.addEventListener('DOMContentLoaded', init);
  [0,250,700,1500,3000].forEach(function(t){ setTimeout(init, t); });
  function stopPgcsMo(){ if(window.__pgcsMo){ try{window.__pgcsMo.disconnect();}catch(_e){} window.__pgcsMo=null; } }
  try{ window.__pgcsMo=new MutationObserver(function(){ init(); }); window.__pgcsMo.observe(document.documentElement,{childList:true,subtree:true}); }catch(_e){}
  setTimeout(stopPgcsMo, 6000);
})();

(function(){
  function wire(){
    var vids = document.querySelectorAll('.pg-lp-customer-video-el');
    if(!vids.length) return;
    function load(v){ if(v.dataset.loaded) return; var s=v.querySelector('source'); if(s&&s.dataset.src){ s.src=s.dataset.src; v.load(); } v.dataset.loaded='1'; }
    if(!('IntersectionObserver' in window)){ vids.forEach(load); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ var v=e.target;
      if(e.isIntersecting){ load(v); var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
      else if(v.dataset.loaded){ v.pause(); } }); }, {threshold:0.5});
    vids.forEach(function(v){ if(!v.dataset.obs){ v.dataset.obs='1'; io.observe(v); } });
  }
  if(document.readyState!=='loading') wire();
  document.addEventListener('DOMContentLoaded', wire);
  [0,300,800,1500,3000].forEach(function(t){ setTimeout(wire, t); });
  try{ var mo=new MutationObserver(wire); mo.observe(document.documentElement,{childList:true,subtree:true}); setTimeout(function(){ try{mo.disconnect();}catch(e){} }, 8000); }catch(e){}
})();

